import React, {useMemo} from 'react'
import {useTranslation} from 'react-i18next'
import {TitledBody} from '../../common/components/TitledBody'
import {Grid} from '@mui/material'
import {useAccessHelpers} from "../../common/util/hooks";
import {SectionedForm} from "../../common/components/SectionedForm";
import {useCallQueueRoutingSection} from "./sections/callQueueRouting";
import {useSelector} from "react-redux";
import {authorizationCodesEnabledSelector, meSelector} from "../../authentication/redux";
import {useCallCenterAgentSettingsSection} from "./sections/callCenterAgentSettings";
import {useCallCenterCodeSection} from "./sections/callCenterCodes";
import {useAuthorizationCodeSection} from "./sections/authorizationCodes";

export const EnterpriseSettings = () => {
    const {t} = useTranslation()
    const {hasWriteAccess} = useAccessHelpers()
    const me = useSelector(meSelector)

    const callQueueRouting = useCallQueueRoutingSection();
    const callCenterAgentSettings = useCallCenterAgentSettingsSection();
    const cdc = useCallCenterCodeSection('CDC');
    const auc = useCallCenterCodeSection('AUC');
    const authorizationCodeSection = useAuthorizationCodeSection();
    const authorizationCodesEnabled = useSelector(authorizationCodesEnabledSelector)

    const formSections = useMemo(() => [
        callQueueRouting,
        ...(authorizationCodesEnabled ? [authorizationCodeSection] : []),
        ...(me?.callCenterCodesEnabled ? [callCenterAgentSettings, cdc, auc] : [])
    ], [
        callQueueRouting, me, callCenterAgentSettings, auc, cdc, authorizationCodeSection, authorizationCodesEnabled
    ])

    return (
        <TitledBody title={t('navigation.settings')}>
            <Grid container>
                <Grid item xs={12} lg={10}>
                    <SectionedForm formSections={formSections} readOnly={!hasWriteAccess}/>
                </Grid>
            </Grid>
        </TitledBody>
    )
}